import { createAction, props } from '@ngrx/store';
import { UnitDetails } from '../../../locums/models/unit-details.model';

export const loadUnitDetails = createAction('[JOB DETAILS COMPONENT] Load Unit Details', props<{ jobId: number }>());

export const loadUnitDetailsSuccess = createAction(
    '[LOCUMS JOB SERVICE API] Load Unit Details for job Success',
    props<{ unitDetails: UnitDetails }>()
);

export const loadUnitDetailsFailure = createAction(
    '[LOCUMS JOB SERVICE API] Load Unit Details for job Failure',
    props<{ error: unknown }>()
);
